export interface LoginHeaderContent {
  logoUrl: string;
  altText: string;
  headerTitle: string;
  headerSubTitle: string;
  contentBodyHeader?: string;
  enterPasswordText?: string;
}
